import colors from "./colors.json";
const getTheme = localStorage.getItem("theme-user-prosif-current");

export const theme = 
    (getTheme === null )
    ? colors.white
    : ( getTheme === "white" )
    ? colors.white
    : colors.black 
;